import { render, staticRenderFns } from "./policyInfo.vue?vue&type=template&id=e9478fa4&scoped=true&"
import script from "./policyInfo.vue?vue&type=script&lang=js&"
export * from "./policyInfo.vue?vue&type=script&lang=js&"
import style0 from "./policyInfo.vue?vue&type=style&index=0&id=e9478fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9478fa4",
  null
  
)

export default component.exports